<template>
    <div class="content-section__column-manage-spacings order-manage-spacings order-manage-spacings-top-bottom">
        <div class="content plugin text-plugin text-container">
            <h2>Fehler beim Übermitteln der Bestellung</h2>

            <p>
                Deine Bestellung konnte nicht übermittelt werden.<br>
                Bitte versuche es später noch einmal oder kontaktiere uns per Telefon oder E-Mail:
                <br><br>
                <a href="tel:+41438186152">043 818 61 52</a><br>
                <a href="mailto:info@oepfelchasper.ch">info@oepfelchasper.ch</a>
            </p>
            <p>
                <a
                    href="#"
                    class="order-address-form__link--before"
                    @click.prevent="goBack"
                >
                    Zurück
                </a>
            </p>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'; // eslint-disable-line
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState({
            mode: state => state.mode,
        }),
    },
    mounted() {
        window.scrollTo(0, 0);

        // GTM VirtualPageview
        const { dataLayer } = window;
        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
                event: 'VirtualPageview',
                virtualPageURL: `/de/${this.mode === 'business' ? 'bio-furs-buro' : 'bio-fur-dihei'}/fehler`,
                virtualPageTitle: `Abo Bestellen ${this.mode === 'business' ? 'Büro' : 'Zuhause'} - Fehler`,
            });
        }
    },
    methods: {
        goBack() {
            this.$router.push('/address');
        },
    },
};
</script>



// WEBPACK FOOTER //
// Error.vue?f2a8687c